const { default: axios } = require("axios");
import Swal from 'sweetalert2';
import $ from 'jquery';
import moment from 'moment';

document.querySelector('#gasSlipRequest') && new Vue({
    el: '#gasSlipRequest',
    data: function () {
        const _urlParams = new URLSearchParams(window.location.search);
        const _prefillDate        = _urlParams.get('date');
        const _prefillAutoApprove = _urlParams.get('auto_approve');

        return {
            date_of_request: _prefillDate || moment().format('YYYY-MM-DD'),
            vehicle_id: null,
            no_of_liters: null,
            driver_id: null,
            passengers: [{
                first_name: null,
                middle_name: null,
                last_name: null,
            }],
            destination: null,
            purpose: null,
            fuel_id: null,
            gas_slip: null,
            excess_in_container: null,
            is_full_tank: 0,
            is_auto_approved: !!_prefillAutoApprove,
            isDateLocked: !!_prefillDate,
            redirectToTripTicket: false,
            // Requester fields
            requester_first_name: null,
            requester_middle_name: null,
            requester_last_name: null,
            requester_designation: null,
            // Temporary storage for vehicle details when showing trip ticket modal
            selectedVehicleTemp: null,
            gas_slip_no: null,
        };
    },
    watch: {
        vehicle_id: async function(newVal, oldVal) {
            // Only check if vehicle_id changed to a truthy value
            if (newVal && newVal !== oldVal) {
                console.log('Watch: vehicle_id changed from', oldVal, 'to', newVal);
                await this.checkAndHandleVehicleChange();
            }
        }
    },
    methods: {
        async checkAndHandleVehicleChange() {
            if (!this.vehicle_id) {
                console.log('No vehicle selected');
                return;
            }

            // Check if the vehicle's latest gas request has a driver trip ticket
            // If status is cancelled/declined, allow new request without trip ticket check
            // If status is approved/filled, require trip ticket
            try {
                console.log('Checking trip ticket for vehicle:', this.vehicle_id);
                const checkBase = "/office/gas-slip-request/vehicle";
                const res = await axios.get(`${checkBase}/${this.vehicle_id}/check-trip-ticket`);

                console.log('Trip ticket check response:', res.data);

                // If server indicates the last request is pending approval
                if (res.data && res.data.pending === true) {
                    console.log('Last gas request pending for vehicle:', this.vehicle_id);
                    new Swal('Info', res.data.message || 'Last gas request is pending approval.', 'info');
                    // Revert selection
                    this.vehicle_id = null;
                    $('#vehicle_select').val(null).trigger('change');
                    return;
                }

                // If trip ticket is missing (ok === false)
                if (res.data && res.data.ok === false) {
                    console.log('Trip ticket required - showing modal for vehicle:', this.vehicle_id);
                    
                    // Store the vehicle details before clearing vehicle_id
                    this.selectedVehicleTemp = this.selectedVehicle;
                    this.gas_slip_no = res.data.gas_slip_no;
                    console.log('Stored vehicle temp:', this.selectedVehicleTemp);
                    console.log('Stored gas_slip_no:', this.gas_slip_no);
                    
                    // Store the gas_request_id for the modal link
                    const link = document.getElementById('tripTicketCreateLink');
                    if (link) {
                        const gasReqId = res.data.gas_request_id || '';
                        const baseHref = link.getAttribute('href').split('?')[0]; // Remove existing params
                        link.href = `${baseHref}?vehicle_id=${this.vehicle_id}&gas_request_id=${gasReqId}`;
                        console.log('Updated trip ticket create link:', link.href);
                    }

                    // Show the modal
                    const tripTicketModal = new coreui.Modal(document.getElementById('tripTicketRequiredModal'));
                    tripTicketModal.show();
                    
                    // Revert the vehicle selection in both Vue and Select2
                    this.vehicle_id = null;
                    $('#vehicle_select').val(null).trigger('change');
                    return;
                } else {
                    console.log('Trip ticket check passed or not required for vehicle:', this.vehicle_id);
                }
            } catch (err) {
                console.error('Error checking trip ticket:', err.response?.data || err.message);
                console.error('Full error:', err);
                // Continue with passenger handling even if check fails
            }


            // Handle passengers after trip ticket check
            this.handleVehiclePassengers();
        },
        handleVehiclePassengers() {
            console.log('Handling passengers for vehicle');
            if (this.selectedVehicleIsForOnePerson) {
                this.passengers = [];
                if (this.selectedDriver != null) {
                    this.passengers.push({
                        first_name: this.selectedDriver.first_name,
                        middle_name: this.selectedDriver.middle_name,
                        last_name: this.selectedDriver.last_name,
                    })
                    this.$forceUpdate();
                }
                else {
                    this.addPassenger();
                }
            }
        },
        async vehicleChange() {
            console.log('vehicleChange called - vehicle_id:', this.vehicle_id);
            // The watcher will handle everything now
            await this.checkAndHandleVehicleChange();
        },
        addPassenger() {
            this.passengers = [
                ...this.passengers, {
                    first_name: null,
                    middle_name: null,
                    last_name: null,
                }
            ]
        },
        deletePassenger(index) {
            var arr = this.passengers;

            arr.splice(index, 1);

            this.passengers = arr;
        },
        confirm() {
            try {
                if (this.date_of_request == null) {
                    throw 'Date of request is required';
                }

                if (this.vehicle_id == null) {
                    throw 'Vehicle is required';
                }

                if (this.no_of_liters == null && this.is_full_tank == 0) {
                    throw 'No. of liters is required';
                }

                if (this.driver_id == null) {
                    throw 'Driver is required';
                }

                if (this.isDestinationRequired && !this.destination) {
                    throw 'Destination is required';
                }

                if (this.purpose == null) {
                    throw 'Purpose is required';
                }

                if (this.fuel_id == null) {
                    throw 'Fuel is required';
                }

                this.redirectToTripTicket = false;
                $('#confirmationModal').modal('show');
            } catch (e) {
                new Swal('Error!', e, 'error');
            }
        },
        confirmAndCreateTripTicket() {
            try {
                if (this.date_of_request == null) throw 'Date of request is required';
                if (this.vehicle_id == null) throw 'Vehicle is required';
                if (this.no_of_liters == null && this.is_full_tank == 0) throw 'No. of liters is required';
                if (this.driver_id == null) throw 'Driver is required';
                if (this.isDestinationRequired && !this.destination) throw 'Destination is required';
                if (this.purpose == null) throw 'Purpose is required';
                if (this.fuel_id == null) throw 'Fuel is required';

                this.redirectToTripTicket = true;
                $('#confirmationModal').modal('show');
            } catch (e) {
                new Swal('Error!', e, 'error');
            }
        },
        async submit() {
            try {
                const res = await axios.post('/office/gas-slip-request', {
                    date_of_request: this.date_of_request,
                    vehicle_id: this.vehicle_id,
                    no_of_liters: this.no_of_liters,
                    driver_id: this.driver_id,
                    passengers: this.selectedPassengers,
                    destination: this.destination,
                    purpose: this.purpose,
                    fuel_id: this.fuel_id,
                    excess_in_container: this.excess_in_container,
                    is_full_tank: this.is_full_tank,
                    is_auto_approved: this.is_auto_approved,
                    requester_first_name: this.requester_first_name,
                    requester_middle_name: this.requester_middle_name,
                    requester_last_name: this.requester_last_name,
                    requester_designation: this.requester_designation,
                    save_and_create_trip_ticket: this.redirectToTripTicket ? 1 : 0,
                })

                this.gas_slip = `/office/gas-slip-request/${res.data['id']}/print`


                this.date_of_request = null;
                this.vehicle_id = null;
                this.no_of_liters = null;
                this.driver_id = null;
                this.passengers = [{
                    first_name: null,
                    middle_name: null,
                    last_name: null,
                }];
                this.destination = null;
                this.purpose = null;
                this.fuel_id = null;
                this.excess_in_container = null;
                this.is_full_tank = 0;
                this.is_auto_approved = false;
                this.requester_first_name = null;
                this.requester_middle_name = null;
                this.requester_last_name = null;
                this.requester_designation = null;

                $('#confirmationModal').modal('hide');
                // $('#gasSlipModal').modal('show');

                if (this.redirectToTripTicket) {
                    window.location.href = '/office/driver-trip-tickets/create?gas_request_id=' + res.data['id'];
                    return;
                }

                new Swal('Success!', 'Gas slip request submitted successfully', 'success');

            } catch (e) {
                if (e?.response?.data?.message != null) {
                    new Swal('Error', e?.response?.data?.message, 'error');
                    return;
                }

                new Swal('Error', e, 'error');
            }
        },
        print() {
            var prtContent = document.getElementById("gasSlipImg");
            var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            WinPrint.document.write(prtContent.innerHTML);
            WinPrint.document.close();
            WinPrint.focus();
            WinPrint.print();
        }
    },
    computed: {
        selectedVehicleIsForOnePerson() {
            if (this.selectedVehicle != null && (
                this.selectedVehicle.type == "Heavy Equipment" ||
                this.selectedVehicle.type == "Generator" ||
                this.selectedVehicle.type == "Other"
            )) {
                return true;
            }

            return false;
        },
        selectedVehicle() {
            if (this.vehicle_id == null) {
                return null;
            }
            if (typeof vehicles === 'undefined') return null;
            return vehicles.find((e) => e.id == this.vehicle_id);
        },

        selectedDriver() {
            if (this.driver_id == null) {
                return null;
            }
            if (typeof drivers === 'undefined') return null;
            return drivers.find((e) => e.id == this.driver_id);
        },
        selectedPassengers() {
            return this.passengers.filter((e) => e.first_name != null || e.last_name != null || e.middle_name != null);
        },
        selectedFuelType() {
            if (this.fuel_id == null) {
                return null;
            }

            return fuelTypes.find((e) => e.id == this.fuel_id);
        },
        filteredFuels() {
            if (this.selectedVehicle == null) {
                return [];
            }
            if (typeof fuelTypes === 'undefined') return [];

            const fuelType = this.selectedVehicle.fuel_type;

            return fuelTypes.filter((e) => e.fuel_type == fuelType);
        },
        isContainer() {
            console.log(this.selectedVehicle);
            if (this.selectedVehicle?.type_specify?.toLowerCase() == 'container') {
                return true;
            }

            if (this.selectedVehicle?.make?.toLowerCase() == 'container') {
                return true;
            }

            if (this.selectedVehicle?.model?.toLowerCase() == 'container') {
                return true;
            }

            return false;
        },
        isDestinationRequired() {
            if (this.selectedVehicle?.type == 'Generator') {
                return false;
            }

            if (this.isContainer) {
                return true;
            }


            if (this.selectedVehicle?.type == 'Other') {
                return false;
            }

            return true;
        }
    },
    mounted() {
        // Initialize Select2
        $('#vehicle_select').select2();
        
        // Listen for Select2 changes
        $('#vehicle_select').on('select2:select', (event) => {
            console.log('Select2 change detected:', event.params.data);
            this.vehicle_id = event.params.data.id;
            // vehicleChange will be triggered by the watcher on vehicle_id
        });

        // Fallback listener for native change events
        $('#vehicle_select').on('change', (event) => {
            console.log('Native change event detected');
            const val = $(event.target).val();
            console.log('Vehicle select value:', val);
            if (val !== this.vehicle_id) {
                this.vehicle_id = val;
            }
        });

        // Sync Select2 with vehicle_id from URL params.
        // Globals (vehicles, fuelTypes, drivers) are now defined in @push('scripts_1')
        // which loads BEFORE admin.js, so no setTimeout needed.
        const prefillVehicleId = new URLSearchParams(window.location.search).get('vehicle_id');
        if (prefillVehicleId) {
            this.vehicle_id = prefillVehicleId;
            this.$nextTick(() => {
                $('#vehicle_select').val(prefillVehicleId).trigger('change.select2');
            });
        }
    }
})
